var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 5.2C3.33203 4.0799 3.33203 3.51984 3.55002 3.09202C3.74176 2.71569 4.04773 2.40973 4.42405 2.21799C4.85187 2 5.41193 2 6.53203 2H9.46536C10.5855 2 11.1455 2 11.5733 2.21799C11.9497 2.40973 12.2556 2.71569 12.4474 3.09202C12.6654 3.51984 12.6654 4.0799 12.6654 5.2V14L7.9987 11.3333L3.33203 14V5.2Z",
    fill: "#8145B5",
    stroke: "#8145B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarked);
export default __webpack_public_path__ + "static/media/Bookmarked.8de4c9926b1195bae6aee1d579c95a6e.svg";
export { ForwardRef as ReactComponent };